'use strict';

var d3 = require('d3');
var Scales = function Scales(params, data) {
  var xRange, yRange;
  data.forEach(function (c) {
    xRange = d3.extent(c.bidPrices, function (d) {
      return d.seatAvailIndex;
    });
    yRange = d3.extent(c.bidPrices, function (d) {
      return d.bidPrice;
    });
  });
  yRange[1] = 1.1 * yRange[1];
  var x = d3.scale.linear().domain(xRange).range([0, params.width]);
  var y = d3.scale.linear().domain(yRange).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;